<template>
  <vs-popup id="popupTemperatureTable" title="체감온도 산출표" :active.sync="isVisible" class="popup-temperature-table">
    <div class="temperature-table-container">
      <!-- 상단 카테고리 태그 -->
      <div class="category-tags mb-4">
        <div class="temp-tag" style="background: #00cfe8;">관심</div>
        <div class="temp-tag" style="background: #ffcd43;">주의</div>
        <div class="temp-tag" style="background: #ff9f43;">경고</div>
        <div class="temp-tag" style="background: #ea5455;">위험</div>
      </div>

      <!-- 체감온도 산출표 -->
      <div class="table-wrapper">
        <table class="temperature-table">
          <thead>
          <tr>
            <th rowspan="2" class="corner-cell">
              <div class="diagonal-cell">
                <span class="top-right">기온</span>
                <span class="bottom-left">습도</span>
              </div>
            </th>
            <th v-for="temp in temperatures" :key="temp" class="temperature-header">{{ temp }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in tableData" :key="index">
            <td class="humidity-header">{{ row.humidity }}</td>
            <td v-for="(value, colIndex) in row.values" :key="colIndex"
                :class="getCellClass(value)"
                class="temperature-cell">
              {{ value.toFixed(1) }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'TemperatureFeelTablePopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  data() {
    return {
      temperatures: [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
      tableData: [
        { humidity: 25, values: [22.2, 23.1, 24.0, 24.9, 25.8, 26.7, 27.6, 28.5, 29.5, 30.4, 31.3, 32.2, 33.1, 34.0, 35.0, 35.9] },
        { humidity: 30, values: [22.8, 23.7, 24.6, 25.5, 26.5, 27.4, 28.3, 29.2, 30.2, 31.1, 32.0, 33.0, 33.9, 34.8, 35.8, 36.7] },
        { humidity: 35, values: [23.3, 24.2, 25.2, 26.1, 27.0, 28.0, 28.9, 29.9, 30.8, 31.8, 32.7, 33.7, 34.6, 35.6, 36.5, 37.5] },
        { humidity: 40, values: [23.8, 24.7, 25.7, 26.6, 27.6, 28.5, 29.5, 30.4, 31.4, 32.4, 33.3, 34.3, 35.3, 36.2, 37.2, 38.2] },
        { humidity: 45, values: [24.2, 25.2, 26.1, 27.1, 28.1, 29.0, 30.0, 31.0, 32.0, 32.9, 33.9, 34.9, 35.9, 36.9, 37.8, 38.8] },
        { humidity: 50, values: [24.6, 25.6, 26.6, 27.6, 28.6, 29.5, 30.5, 31.5, 32.5, 33.5, 34.5, 35.4, 36.4, 37.4, 38.4, 39.4] },
        { humidity: 55, values: [25.1, 26.0, 27.0, 28.0, 29.0, 30.0, 31.0, 32.0, 33.0, 34.0, 35.0, 36.0, 37.0, 38.0, 39.0, 40.0] },
        { humidity: 60, values: [25.5, 26.5, 27.5, 28.4, 29.4, 30.4, 31.4, 32.4, 33.5, 34.5, 35.5, 36.5, 37.5, 38.5, 39.5, 40.5] },
        { humidity: 65, values: [25.9, 26.9, 27.9, 28.9, 29.9, 30.9, 31.9, 32.9, 33.9, 34.9, 35.9, 36.9, 38.0, 39.0, 40.0, 41.0] },
        { humidity: 70, values: [26.2, 27.2, 28.2, 29.3, 30.3, 31.3, 32.3, 33.3, 34.3, 35.4, 36.4, 37.4, 38.4, 39.5, 40.5, 41.5] },
        { humidity: 75, values: [26.6, 27.6, 28.6, 29.7, 30.7, 31.7, 32.7, 33.7, 34.8, 35.8, 36.8, 37.8, 38.8, 39.9, 40.9, 42.0] },
        { humidity: 80, values: [27.0, 28.0, 29.0, 30.0, 31.1, 32.1, 33.1, 34.1, 35.2, 36.2, 37.2, 38.1, 39.3, 40.3, 41.4, 42.4] },
        { humidity: 85, values: [27.3, 28.4, 29.4, 30.4, 31.4, 32.5, 33.5, 34.5, 35.6, 36.6, 37.7, 38.7, 39.7, 40.8, 41.8, 42.9] },
        { humidity: 90, values: [27.7, 28.7, 29.7, 30.8, 31.8, 32.9, 33.9, 34.9, 36.0, 37.0, 38.1, 39.1, 40.2, 41.2, 42.3, 43.3] },
        { humidity: 95, values: [28.0, 29.1, 30.1, 31.1, 32.2, 33.2, 34.3, 35.3, 36.4, 37.4, 38.5, 39.5, 40.6, 41.6, 42.7, 43.7] },
        { humidity: 100, values: [28.4, 29.4, 30.5, 31.5, 32.6, 33.6, 34.6, 35.7, 36.7, 37.8, 38.9, 39.9, 41.0, 42.0, 43.1, 44.1] }
      ]
    }
  },
  methods: {
    getCellClass(value) {
      if (value >= 38) return 'danger'
      if (value >= 35) return 'warning'
      if (value >= 33) return 'caution'
      if (value >= 31) return 'attention'
      return 'normal'
    }
  }
}
</script>

<style scoped lang="scss">
.popup-temperature-table::v-deep {
  .vs-popup {
    width: 900px;
    max-width: 900px;
  }
}


.temperature-table-container {
  padding: 20px;
}

.category-tags {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 20px;
}

.temp-tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #333;
  border-radius: 4px;
}

.temperature-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.temperature-table th,
.temperature-table td {
  border: 1px solid #444;
  text-align: center;
  padding: 4px 6px;
  min-width: 35px;
}

.corner-cell {
  background-color: #f8f9fa;
  font-weight: bold;
  font-size: 12px;
  line-height: 1.2;
  position: relative;
  padding: 0 !important;
  background-image: linear-gradient(to left bottom, transparent calc(50% - 1px), #444, transparent calc(50% + 1px));
  background-size: 120% 120%;
  background-position: center;
}

.diagonal-cell {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 40px;
}

.diagonal-cell .top-right {
  position: absolute;
  top: 3px;
  right: 3px;
  font-size: 11px;
  font-weight: bold;
  color: #333;
}

.diagonal-cell .bottom-left {
  position: absolute;
  bottom: 3px;
  left: 3px;
  font-size: 11px;
  font-weight: bold;
  color: #333;
}

.temperature-header {
  background-color: #E3F8FF;
  font-weight: bold;
  font-size: 12px;
}

.humidity-header {
  background-color: #E5E5E5;
  font-weight: bold;
  font-size: 12px;
}

.temperature-cell {
  font-size: 12px;
  font-weight: 500;
}

/* 체감온도별 색상 */
.temperature-cell.normal {
  background-color: #ffffff;
  color: #333;
}

.temperature-cell.attention {
  background-color: #42C7F1;
  color: #01579b;
}

.temperature-cell.caution {
  background-color: #FFE766;
  color: #e65100;
}

.temperature-cell.warning {
  background-color: #FF843A;
  color: #3E1800;
}

.temperature-cell.danger {
  background-color: #FF0000;
  color: #2A0101;
  font-weight: bold;
}
</style>
